//import React, 
import { useEffect,useLayoutEffect, useState, useRef } from "react";
import SearchResult from "./SearchResult";
import {
  operations as searchoperations,
  selectors as searchResultSelector,
} from "../../redux/SearchResult";
import { useDispatch, useSelector } from "react-redux";

import { selectors as loginSelector } from "../../redux/Login";
import { selectors as searchSelector } from "../../redux/SearchResult";

const SearchResultContainer = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const apiKey = localStorage.getItem('key');
  const searchedStorage = sessionStorage.getItem('search');  
  const chartRef = useRef(null);

  const [chartWidth, setChartWidth] = useState(0);
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();
  const dispatchGetSearchResult =
    searchoperations.dispatchGetSearchResult(dispatch);
  const dispatchSetRandomChart = searchoperations.dispatchSetRandomChart(dispatch);
  const { loginAPI, search } = useSelector((state) => ({
    loginAPI: loginSelector.loginAPI(state),
    search: searchSelector.search(state),
  }));

  const { searchedData, randomData, barChart } = useSelector((state) => ({
    searchedData: searchResultSelector.searchedData(state),
    randomData: searchResultSelector.randomChart(state),
    barChart: searchResultSelector.barChart(state)
  }));

  const resizeFun = () => {
    let width = 0;
    if(chartRef?.current?.offsetWidth) {
      width = chartRef?.current?.clientWidth;
      setChartWidth(Math.floor(width));

    }
  }

  useEffect(() => {
    if (searchedData) {
      setLoader(false);
    }
  }, [searchedData]);


  useLayoutEffect(()=> {
    window.addEventListener('resize', resizeFun);
    return () => {
      window.removeEventListener('resize',resizeFun);
    }
  },[chartRef]);

  useLayoutEffect(()=> {
    resizeFun();
  },[chartRef, barChart]);

  useEffect(()=> {
    if(!search && searchedStorage) {
      setSearchQuery(searchedStorage);
      const data = { key: loginAPI, q: searchedStorage };
      dispatchGetSearchResult(data);
      setLoader(true);
    }
    dispatchSetRandomChart({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
 
  useEffect(() => {
    if (search) {
      setSearchQuery(search);
      sessionStorage.setItem('search',search);
      setLoader(true);
      const data = { key: loginAPI, q: search };
      dispatchGetSearchResult(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);


  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };


  function handleEnter(event) {
    let key = (loginAPI || apiKey );
    if (event.keyCode === 13) {
      if(searchQuery.trim()) {
        dispatchSetRandomChart({});
        setLoader(true)
        const data = { key: key, q: searchQuery };
        if (searchQuery && key) {
          dispatchGetSearchResult(data);
        }
      }
    }
  }

  const handleSearch = () => {
    let key = (loginAPI || apiKey );
    if (key && searchQuery) {
      if(searchQuery.trim()) {
        setLoader(true)
        const data = { key: key, q: searchQuery };
        dispatchSetRandomChart({});
        dispatchGetSearchResult(data);
      }
    }
  };

  return (
    <SearchResult
      searchQuery={searchQuery}
      handleChange={handleChange}
      handleSearch={handleSearch}
      searchedData={searchedData}
      loader={loader}
      handleEnter={handleEnter}
      randomData={randomData}
      chartRef={chartRef}
      chartWidth={chartWidth}
    />
  );
};

export default SearchResultContainer;
